import '@fontsource/lexend/400.css';
import '@fontsource/lexend/700.css';
import '@fontsource/rubik/400.css';

import './lib/sentry';
import * as Sentry from '@sentry/react';
import { Agentation } from 'agentation';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';

import { AppToaster } from './components/AppToaster';
import { AuthProvider } from './contexts/auth.context';
import { LanguageProvider } from './contexts/language.context';
import './index.css';
import './lib/i18n';
import { UserProvider } from './contexts/user.context';
import DashboardRouter from './features/DashboardRouter.tsx';

const container = document.getElementById('root')!;
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo?.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <BrowserRouter>
    <AuthProvider>
      <LanguageProvider>
        <UserProvider>
          <Routes>
            <Route path="/*" element={<DashboardRouter />} />
          </Routes>
          <AppToaster />
          {import.meta.env.DEV && <Agentation endpoint="http://localhost:4747" />}
        </UserProvider>
      </LanguageProvider>
    </AuthProvider>
  </BrowserRouter>,
);
